function orderReviewModal() {
    if (!document.querySelector('.js-order-review-btn')) return;

    const btns = document.querySelectorAll('.js-order-review-btn');

    btns.forEach(btn => {
        const productId = btn.dataset.productId;

        btn.addEventListener('click', (e) => {
            modals.openModal(null, "#orders-review", (modal) => {
                const inputProduct = modal.querySelector('[name="fields[product-id]"]');

                inputProduct.value = productId;
            })
        })
    })
}
